export default {
  colorPrimary: '#967557',
  colorBackground: '#8B7565',
  headerHeight: '88px',
  headerMobileWidth: '830px',
  headerMobileHeight: '62px',
  font: 'Helvetica Neue LT Std',
  fontCn: 'Helvetica Neue LT Std Cn',
  fontLight: 'Helvetica Neue LT Std Light',
  fontMedium: 'Helvetica Neue LT Std Med',
  fontMediumCn: 'Helvetica Neue LT Std Med Cn',
  fontBold: 'Helvetica Neue LT Std Bold',
  fontHeader: 'Garamond Premiere Pro',
};



// WEBPACK FOOTER //
// ./src/styles/theme.js